import React from "react";

export default function LandingPage() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(120deg, #E53935 0%, #0288D1 100%)",
      padding: 0,
      margin: 0,
      fontFamily: "Inter, Arial, sans-serif"
    }}>
      {/* HERO SECTION */}
      <div style={{
        maxWidth: 560,
        margin: "0 auto",
        background: "#fff",
        borderRadius: 32,
        marginTop: 48,
        padding: "44px 36px 36px 36px",
        boxShadow: "0 6px 42px #0002",
        textAlign: "center"
      }}>
        <img src="logo.png" alt="Fox Fuel" style={{height: 54, marginBottom: 12}} />
        <h1 style={{color: "#E53935", fontWeight: 900, fontSize: 36, margin: 0}}>Find Your Perfect Heating Oil Plan</h1>
        <div style={{color: "#0288D1", fontSize: 21, margin: "18px 0 0 0", fontWeight: 600}}>
          Personalized plan recommendations in under 60 seconds.
        </div>
        <div style={{color: "#222", fontSize: 16, margin: "10px 0 24px 0"}}>
          Just answer a few quick questions and get instant pricing, monthly payment estimates, and side-by-side plan comparisons—no commitment, no spam.
        </div>
        <a href="/app" /* replace with your selector route or Netlify URL */
          style={{
            background: "linear-gradient(90deg, #E53935 0%, #FFC107 100%)",
            color: "#fff",
            fontWeight: 700,
            fontSize: 22,
            borderRadius: 18,
            padding: "18px 36px",
            textDecoration: "none",
            boxShadow: "0 2px 18px #e5393522",
            display: "inline-block",
            marginBottom: 16
          }}>
          Start My Plan Selector →
        </a>
        <div style={{
          fontSize: 14,
          color: "#757575",
          marginBottom: 6
        }}>
          <span style={{
            display: "inline-block",
            background: "#0288D1",
            color: "#fff",
            borderRadius: 10,
            padding: "3px 12px",
            fontSize: 15,
            fontWeight: 600
          }}>
            Takes less than a minute
          </span>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div style={{
        maxWidth: 600,
        margin: "36px auto 0 auto",
        background: "#fff",
        borderRadius: 24,
        padding: "28px 34px",
        boxShadow: "0 2px 16px #0288d122",
        textAlign: "center"
      }}>
        <h2 style={{color: "#0288D1", fontWeight: 800, fontSize: 28, margin: "0 0 12px 0"}}>How it Works</h2>
        <div style={{display: "flex", justifyContent: "space-between", gap: 18, flexWrap: "wrap"}}>
          <div style={{flex: 1, minWidth: 120}}>
            <div style={{fontSize: 38}}>❓</div>
            <div style={{fontWeight: 700}}>1. Answer a few questions</div>
          </div>
          <div style={{flex: 1, minWidth: 120}}>
            <div style={{fontSize: 38}}>⚡</div>
            <div style={{fontWeight: 700}}>2. Get instant plan recommendations</div>
          </div>
          <div style={{flex: 1, minWidth: 120}}>
            <div style={{fontSize: 38}}>📋</div>
            <div style={{fontWeight: 700}}>3. Request a personalized quote</div>
          </div>
        </div>
      </div>

      {/* TRUST & FEATURE HIGHLIGHTS */}
      <div style={{
        maxWidth: 600,
        margin: "36px auto 0 auto",
        background: "#F5F5F5",
        borderRadius: 24,
        padding: "24px 32px",
        boxShadow: "0 1px 8px #E5393511"
      }}>
        <div style={{display: "flex", gap: 20, flexWrap: "wrap"}}>
          <div style={{flex: 1, minWidth: 190}}>
            <div style={{fontWeight: 700, color: "#0288D1"}}>Serving PA since 1981</div>
            <div style={{fontSize: 14}}>Thousands of families trust Fox Fuel for heating oil and service.</div>
          </div>
          <div style={{flex: 1, minWidth: 190}}>
            <div style={{fontWeight: 700, color: "#0288D1"}}>Transparent Pricing</div>
            <div style={{fontSize: 14}}>Real prices, no hidden fees, no surprises.</div>
          </div>
          <div style={{flex: 1, minWidth: 190}}>
            <div style={{fontWeight: 700, color: "#0288D1"}}>No Commitment Needed</div>
            <div style={{fontSize: 14}}>Get a quote with zero obligation and total privacy.</div>
          </div>
        </div>
      </div>

      {/* TESTIMONIAL & FAQ */}
      <div style={{
        maxWidth: 600,
        margin: "36px auto 0 auto",
        padding: "12px 0 30px 0"
      }}>
        <div style={{
          fontStyle: "italic",
          color: "#0288D1",
          fontWeight: 500,
          fontSize: 18,
          marginBottom: 14
        }}>
          “I used the selector and got my quote in seconds. Love the simplicity and honest pricing!” <br />
          <span style={{fontWeight: 400, color: "#555"}}>- Jane D., Willow Grove</span>
        </div>
        <div style={{
          background: "#fff",
          borderRadius: 14,
          padding: "14px 20px",
          fontSize: 15,
          color: "#222",
          boxShadow: "0 1px 8px #0288d111"
        }}>
          <b>FAQ:</b>
          <ul style={{margin: "8px 0 0 0", padding: "0 0 0 18px"}}>
            <li>Is this tool free? <b>Yes, it’s 100% free.</b></li>
            <li>Do I have to buy right away? <b>No, you get all plan info with zero commitment.</b></li>
            <li>Will I get spammed? <b>No. Your info is used only to provide your quote.</b></li>
          </ul>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{
        marginTop: 50,
        textAlign: "center",
        color: "#666",
        fontSize: 15
      }}>
        <div>
          <b>Questions?</b> Call <a href="tel:215-555-1212" style={{color: "#E53935"}}>215-555-1212</a> or <a href="mailto:info@foxfuel.com" style={{color: "#0288D1"}}>info@foxfuel.com</a>
        </div>
        <div style={{marginTop: 8}}>
          <a href="/privacy" style={{color: "#888"}}>Privacy Policy</a> | &copy; {new Date().getFullYear()} Fox Fuel
        </div>
      </footer>
    </div>
  );
}
